import { render, staticRenderFns } from "./FrontendApiSearch.vue?vue&type=template&id=a50c398a"
import script from "./FrontendApiSearch.vue?vue&type=script&lang=js"
export * from "./FrontendApiSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports